import { render, staticRenderFns } from "./final-plat-who-pays.vue?vue&type=template&id=7a65f792"
import script from "./final-plat-who-pays.vue?vue&type=script&lang=js"
export * from "./final-plat-who-pays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports